import { DEBOUNCE_INPUT_MS } from "constant/app";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

class ClearableInput extends React.PureComponent {
  static get propTypes() {
    return {
      debounceMs: PropTypes.number,
      initialValue: PropTypes.string,
      onSubmit: PropTypes.func.isRequired,
      placeholder: PropTypes.string,
      submitButton: PropTypes.node,
      submitOnChange: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      debounceMs: DEBOUNCE_INPUT_MS,
      initialValue: "",
      placeholder: "",
      submitOnChange: false,
    };
  }

  constructor(props) {
    super(props);

    this._clearValue = this._clearValue.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onKeyPress = this._onKeyPress.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._debouncedSubmit = debounce(this._onSubmit, props.debounceMs);

    this._lastSearch = props.initialValue;

    this._clearButtonClass =
      "form-control-clear form-control-feedback " +
      "fa fa-times";
    this.state = {
      value: props.initialValue,
    };
  }

  _clearValue() {
    this.setState({ value: "" }, this._onSubmit);
  }

  _onChange(e) {
    this.setState({ value: e.target.value }, () => {
      if (this.props.submitOnChange) {
        this._debouncedSubmit();
      }
    });
  }

  _onKeyPress(e) {
    if (e.key === "Enter") {
      this._onSubmit();
    }
  }

  _onSubmit() {
    const { onSubmit } = this.props;

    if (this.state.value === this._lastSearch) {
      return;
    }

    this._lastSearch = this.state.value;

    onSubmit(this.state.value);
  }

  render() {
    const { _clearButtonClass } = this;
    const { placeholder, submitButton } = this.props;
    const { value } = this.state;

    const clearClass = value
      ? _clearButtonClass
      : `${_clearButtonClass} hidden`;

    return (
      <InputGroup className="ui-clearable-input">
        <Form.Group className="has-feedback has-clear">
          <Form.Control
            type="text"
            className="search-box"
            onChange={this._onChange}
            onKeyUp={this._onKeyPress}
            placeholder={placeholder}
            value={value}
          />
          <span className={clearClass} onClick={this._clearValue} />
          {submitButton && (
            <InputGroup.Append onClick={this._onSubmit}>
              {submitButton}
            </InputGroup.Append>
          )}
        </Form.Group>
      </InputGroup>
    );
  }
}

export { ClearableInput };
